import { useTranslation } from '@/i18n';
import { ButtonV2 } from '@moneyforward/ap-frontend-components';
import { UpdateAiAgentServiceSettingsResultServiceType } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC } from 'react';
import { FormProvider } from 'react-hook-form';
import { HeaderSection } from '../Common';
import { INVOICE_DOWNLOAD_SERVICE_DETAIL_LINK } from './constants';
import { useAiAgentServicesSetting } from './hooks/useAiAgentServicesSetting';
import { InvoiceDownloadService } from './InvoiceDownloadService';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type AiAgentServicesSettingProps = {
  isMainSettingEnabled: boolean;
  setIsEditingServices: (isEditingServices: boolean) => void;
  isEditingServices: boolean;
} & {
  [key in UpdateAiAgentServiceSettingsResultServiceType]?: boolean;
};

export const AiAgentServicesSetting: FC<AiAgentServicesSettingProps> = ({
  isMainSettingEnabled,
  setIsEditingServices,
  isEditingServices,
  invoice_download_agent = false,
}) => {
  const { t } = useTranslation();
  const { methods, handleEdit, handleCancel, handleSave, isUpdating } =
    useAiAgentServicesSetting({
      invoice_download_agent,
      setIsEditingServices,
    });

  return (
    <FormProvider {...methods}>
      <div className={cx('aiAgentServicesSettingContainer')}>
        <HeaderSection
          displayName={
            <span className={cx('aiAgentServicesSettingTitleText')}>
              {t('ai_agents_setting_services_section_title')}
            </span>
          }
          actionButton={
            !isEditingServices ? (
              <ButtonV2
                color='primary'
                isSecondary
                size='xs'
                type='button'
                isDisabled={!isMainSettingEnabled}
                onClick={handleEdit}
              >
                {t('edit')}
              </ButtonV2>
            ) : (
              <div className={cx('editModeActions')}>
                <ButtonV2
                  color='primary'
                  isSecondary
                  size='xs'
                  type='button'
                  onClick={handleCancel}
                  isDisabled={isUpdating}
                >
                  {t('cancel')}
                </ButtonV2>
                <ButtonV2
                  color='primary'
                  size='xs'
                  type='button'
                  onClick={handleSave}
                  isDisabled={isUpdating}
                  isLoading={isUpdating}
                  isTransparent={isUpdating}
                  buttonContainerClassName={cx('saveButton')}
                >
                  {t('save')}
                </ButtonV2>
              </div>
            )
          }
        />
        <div className={cx('aiAgentServicesSettingContent')}>
          <InvoiceDownloadService
            isEditMode={isEditingServices}
            name='invoice_download_agent'
            initialValue={invoice_download_agent}
            detailLink={INVOICE_DOWNLOAD_SERVICE_DETAIL_LINK}
          />
        </div>
      </div>
    </FormProvider>
  );
};
